import React, {PureComponent} from "react";
import Api from "../../utils/api_calls";
import Common from "../../utils/common";
import Playerlib from "../../libs/player";
import Analytics from "../../libs/analytics";
import AssetDetails from "../AssetDetails/AssetDetails";
import "./Player.scss";
import Products from "../Products/Products";
import * as actionTypes from "../../store/actions";
import { StoreContext } from "../../contexts/store";
import Dotdotdot from "react-dotdotdot";
import PlayerEndOverlay from "../PlayerEndOverlay/PlayerEndOverlay";
import { createBrowserHistory } from 'history'
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import theme from "../../../sass/variables.json";
import {Grid} from "@mui/material";

const history = createBrowserHistory();

class Player extends PureComponent {
    static contextType = StoreContext;
    constructor(props) {
        super(props);
        const {asset:{matched, owner}} = props;
        const asset = props.asset || {};
        this.state = {
            hasProducts: matched && matched.length > 0,
            products: matched || [],
            asset,
            player: null,
            ambassador: owner || null,
            nextAsset: null,
            showEndOverlay: false
        };
        if (matched.length) {
            this.setProductsResponse(matched);
        }
    }

    setProductsResponse = (products) => {
        const that = this;
        const {asset} = this.state;
        let newState = {};
        if (!products || !products.length) {
            newState = {
                hasProducts: false,
                products: []
            };
        } else {
            for (let index = 0; index < products.length; index++) {
                let element = products[index];
                Analytics.productImpresion(element, asset.id);
                Common.createProductStructureData(element);
            }
            newState = {
                products,
                hasProducts: true
            };
            setTimeout(() => {
                that.state.player.resize();
            }, 100);
        }
        that.setState(newState);
        return newState.hasProducts;
    }
    storeSubscribe = (storeState) => {
        const {player} = this.state;
        if (storeState.event === actionTypes.UPDATE_ASSET) {
            this.setState({
                nextAsset: storeState.asset,
                showEndOverlay: true
            });
        }else if(storeState.event === actionTypes.UPDATE_PRODUCT_MODAL){
            if(storeState.product_modal.modalOpen){
                player.instance.pause();
            }else{
                player.instance.removeOverlay();
                player.instance.play();
            }
        }
    }
    playerStateChange = (e) => {
        if ('tvp:media:videoended' === e) {
            setTimeout(() => {
                this.context.dispatch({
                    type: actionTypes.PLAYER_EVENT,
                    player_event: e
                })
            }, 200);
        }
    }
    play = () => {
        const {nextAsset, player} = this.state;
        document.querySelector('.video-playing-title').innerHTML = nextAsset.title;
        history.push(Common.getVideoPageUrl(nextAsset));
        player.loadSelected(nextAsset);
        this.setCurrentAsset(nextAsset.id);
        this.setState({
            asset: nextAsset,
            showEndOverlay: false
        });
    }
    replay = () => {
        const {asset, player} = this.state;
        player.loadSelected(asset);
        this.setCurrentAsset(asset.id);
        this.setState({
            showEndOverlay: false
        });
    }

    setCurrentAsset(assetId) {
        this.context.dispatch({
            type: actionTypes.CURRENT_VIDEO,
            CURRENT_VIDEO: assetId
        })
    }

    initPlayer() {
        const options = {
            play_button_border_radius: '50%',
            play_button_border_width: '5px',
            play_button_border_color: theme.play_icon_color,
            play_button_border_style: 'solid',
            play_button_background_color: theme.play_icon_color,
            overlay_opacity: 1,
            poster: true,
            progress_color: theme.player_progressbar_color,
            api_base_url: ConfigurationHelper.getGlobalConfiguration().apiUrl,
            data: [this.state.asset],
            analytics: true,
            autoplay: true,
            autonext: true,
            loginId: ConfigurationHelper.getGlobalConfiguration().loginId,
            playerStateChange: this.playerStateChange
        };
        const globalConfig = {
            playerStateChange: this.playerStateChange
        }
        return new Playerlib('tvpageplayer', options, globalConfig);
    }

    componentDidMount() {
        const player = this.initPlayer();
        this.setState({player: player});
        this._lastState = this.context.state;
    }

    componentDidUpdate() {
        const storeState = this.context.state;
        if (storeState === this._lastState) return;
        this._lastState = storeState;
        this.storeSubscribe(storeState);
    }

    render() {
        const {asset, nextAsset, showEndOverlay, products, hasProducts, ambassador} = this.state;
        const {enableDetails, userTotalVideos} = this.props;
        const userHashId = ambassador && ambassador.hashId ? ambassador.hashId : null;
        const publishedDate = Common.getDateFromUnix(asset.date_created);
        return (
            <div data-testid="tvp-player" ref="tvpageplayer">
                <div className="tvp-player-products-container">
                    <div id="player-container" className="player-container">
                        <Grid container>
                            <div id="video-playing-title-holder">


                                <h1 id="video-playing-title" className="video-playing-title">
                                    <Dotdotdot clamp={2}>
                                        {asset.title}
                                    </Dotdotdot>
                                </h1>


                            </div>
                        </Grid>
                        <Grid container>
                            <div className={"time-date-container"}>
                                {(asset.asset && asset.asset.prettyDuration) && <div className={"tvp-duration"}>
                                    <span>Duration:</span>
                                    <span> {asset.asset.prettyDuration}</span>
                                </div>}

                            </div>
                        </Grid>
                        <Grid container>
                            {enableDetails && <AssetDetails userTotalVideos={userTotalVideos} asset={asset} publishedDate={publishedDate} ambassador={ambassador} enableAmbassador/>}
                        </Grid>
                        <Grid container spacing={2}>

                                    <Grid item id="tvpageplayer-container"
                                          xs={12}
                                          lg={(hasProducts ? 6 : 12)}>
                                        <div id="tvpageplayer-wrapper" className="TVPagePlayer-wrapper">
                                            <div id="tvpageplayer" className="tvp-player">
                                            </div>
                                            {
                                                showEndOverlay &&
                                                <PlayerEndOverlay play={this.play} replay={this.replay} asset={asset}
                                                                  nextAsset={nextAsset}/>
                                            }
                                        </div>
                                    </Grid>

                                    {hasProducts && <Products asset={asset} userHashId={userHashId} products={products}/>}


                        </Grid>
                        
                    </div>
                </div>
            </div>
        );
    }
}

Player.defaultProps = {
    enableDetails: true
};

export default Player;
